
//EXTERNAL API
import LocationsService from "./LocationsService"; 

export const $locationsApi = {
    locations: new LocationsService(),
};